import type { ComponentType } from 'react'

import { StepVisualDeal } from './visuals/StepVisualDeal'
import { StepVisualFilters } from './visuals/StepVisualFilters'
import { StepVisualProduct } from './visuals/StepVisualProduct'
import { StepVisualScoring } from './visuals/StepVisualScoring'
import { StepVisualSequences } from './visuals/StepVisualSequences'
import { StepVisualShortlist } from './visuals/StepVisualShortlist'

/**
 * The six steps of "How it works", in one list for both layouts: the alternating rows of the desktop
 * (HowItWorks.tsx) and the swipe rail of the phone (HowRail.tsx). One list, so a step added, dropped
 * or re-worded cannot reach one layout and miss the other.
 */
export type Step = {
  n: string
  /** Ветка в `landing.how.steps.*`. */
  key: string
  soon?: boolean
  /* Компонент, а не готовый элемент: миниатюре шага 01 нужно знать, что строка доехала до кадра —
     её цикл из двух экранов должен начинаться с первого, а не заставать читателя на середине.
     Остальные пять проп не объявляют и просто его игнорируют. */
  Visual: ComponentType<{ playing?: boolean }>
  /**
   * Куда смотрит кадр ТЕЛЕФОНА, доли от 0 до 1 по каждой оси: 0 — левый (верхний) край миниатюры,
   * 1 — правый (нижний), 0.5 — середина. Десктоп этих чисел не читает.
   *
   * Зачем. Миниатюра свёрстана на 320×180, и её подписи 5.5–8.5px (мобильный аудит 2026-09-28,
   * f1212): во всю ширину телефона она выходит в ×1.04, и текст не прочесть. Рельс показывает её в
   * ×1.5, где подписи 9–13px, а значит в кадр входит примерно две трети ширины. Какие именно две
   * трети — решает этот сдвиг, поштучно, по тому, где у каждой картинки смысл. Доли, а не пиксели:
   * на 360 и на 390 окно разной ширины, а «левый край» остаётся левым краем.
   */
  pan: { x: number; y: number }
}

export const STEPS: Step[] = [
  /* Поле ссылки и разбор под ним начинаются слева; кнопка «Read my product» режется, поле — нет. */
  { n: '01', key: 'connect', Visual: StepVisualProduct, pan: { x: 0, y: 0 } },
  /* Число совпадений и подписи строк стоят у левого края, чипы со счётом идут от них. */
  { n: '02', key: 'filters', Visual: StepVisualFilters, pan: { x: 0, y: 0.5 } },
  /* Смысл кадра — четыре подписи справа, веер линий слева их только подводит. */
  { n: '03', key: 'score', Visual: StepVisualScoring, pan: { x: 0.85, y: 0.5 } },
  /* Имя, сигналы и «why it matches» — левая колонка; балл справа уходит за край. */
  { n: '04', key: 'shortlist', Visual: StepVisualShortlist, pan: { x: 0, y: 0.5 } },
  /* Помечен «скоро»: последовательностей в движке нет, есть одно первое касание
     (POST /api/runs/:id/draft). Обещание на лендинге не должно быть молчаливым. */
  { n: '05', key: 'sequence', soon: true, Visual: StepVisualSequences, pan: { x: 0, y: 0.5 } },
  /* «Call confirmed», дата и время звонка — слева; имя собеседника справа уходит за край. */
  { n: '06', key: 'close', Visual: StepVisualDeal, pan: { x: 0, y: 0.5 } },
]
